export  function getAmsterdamOffset() {
    const now = new Date();
    const amsterdamTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
    const utcTime = new Date(now.toLocaleString('en-US', { timeZone: 'UTC' }));
    const offsetMs = amsterdamTime - utcTime;
    const offsetHours = offsetMs / (1000 * 60 * 60); // Convert to hours
    return offsetHours; 
  }

  